<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            Wholesalers
        </li>
    </ol>
</nav>
<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center mb-3 gx-2">
                <div class="col-9 col-md-6">
                    <h5 class="mb-0 text-dark fw-bold">Wholesalers</h5>
                </div>
                @if(userDataService?.roleMatch(['WHOLESALER-ADD'])){
                <div class="col-3 col-md-6 d-flex  justify-content-end ">
                    <button type="button"
                        class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                        (click)="openModel('Add',null)" style="width: 25px; height: 25px;">
                        <mat-icon fontIcon="add" class="d-flex align-items-center justify-content-center"></mat-icon>
                    </button>
                </div>
                }
            </div>
            <hr class="p-0 m-0">
            <hr class="p-0 m-0">

            <div class="row">
                <div class="col-lg-4">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search by Name, Email, GST No, or Phone</mat-label>
                        <input matInput [(ngModel)]="filter.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>

                <div class="col-lg-4">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By City/State</mat-label>
                        <input matInput [(ngModel)]="filter.cityState" name="cityState"
                            (input)="onCityStateChange($event)">
                    </mat-form-field>
                </div>
                @if(!isCompanyLoggedIn){
                <div class="col-lg-4 ">
                    <ng-select [items]="allCompanies" bindLabel="name" bindValue="_id" placeholder="Select Company"
                        [(ngModel)]="filter.companyId" name="companyId" (change)="companyFilter($event)">
                    </ng-select>
                </div>
                }
            </div>

            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="compact-table table-bordered">
                        <!-- Position Column -->
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <!-- <ng-container matColumnDef="company">
                            <th mat-header-cell *matHeaderCellDef> Company </th>
                            <td mat-cell *matCellDef="let element"> {{element?.company?.name}} </td>
                        </ng-container> -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>WHL Name </th>
                            <td mat-cell *matCellDef="let element"> {{element?.distributor?.name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="contact">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> Contact </th>
                            <td mat-cell *matCellDef="let element" class="text-nowrap">
                                <div class="d-flex flex-column gap-1">

                                    <div>
                                        <i class="bi bi-envelope-fill me-1 text-secondary"></i> {{
                                        element?.distributor.email }}
                                    </div>
                                    <div><i class="bi bi-telephone-fill me-1 text-secondary"></i> {{
                                        element?.distributor.phone }}</div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cordinates">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Coordinates (Lng, Lat)
                            </th>
                            <td mat-cell *matCellDef="let element">
                                @if (element.distributor?.location?.coordinates[0] !== 0
                                || element.distributor?.location?.coordinates[1] !== 0) {
                                {{ element.distributor?.location?.coordinates[0] }} <br>
                                {{ element.distributor?.location?.coordinates[1] }}
                                } @else {
                                Location not available
                                }

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 200px;">Address</th>
                            <td mat-cell *matCellDef="let element" class="text-nowrap">
                                <div style="width: 200px; white-space: normal; word-wrap: break-word;">
                                    {{ element?.distributor?.address }},
                                    <br>
                                    {{ element?.distributor?.city }},
                                    {{ element?.distributor?.state }}
                                </div>
                            </td>
                        </ng-container>
                        <!-- Symbol Column -->
                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap"> Created At </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.distributor.createdAt | date:'dd/MM/yyyy' }}<br>
                                <small>{{ element.distributor.createdAt | date:'hh:mm a' }}</small>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="isBlocked">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element">
                                @if(userDataService?.roleMatch(['WHOLESALER-DELETE'])){
                                <ng-toggle [value]="!element.isBlocked"
                                    [color]="{ unchecked: '#939da2', checked: '#006B88' }"
                                    (click)="wholeSalerStatus(element)" [width]="30" [height]="15">
                                </ng-toggle>
                                }
                                @else {
                                @if (element.isBlocked) {
                                Inactive
                                }
                                @else {
                                Active
                                }
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="samples">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap text-center"> Samples </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <mat-icon aria-hidden="false" aria-label="View Samples" fontIcon="visibility"
                                        class="c_btn" [routerLink]="['/sample/issuedToDistributors', element._id, 1]">
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="retailers">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap text-center">
                                Distributors<br>List
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <mat-icon aria-hidden="false" aria-label="View Retailers" fontIcon="visibility"
                                        class="c_btn" [routerLink]="['/retailer/underWhl', element._id]">
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        @if(userDataService?.roleMatch(['SAMPLE-ASSIGN'])){
                        <ng-container matColumnDef="assign_sample">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                + Assign <br>Sample
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <i class="bi bi-clipboard-plus c_btn" title="Assign Sample"
                                        [routerLink]="['/samples/assign/distributor', element._id,1]">
                                    </i>
                                </div>
                            </td>
                        </ng-container>
                        }
                        @if(userDataService?.roleMatch(['WHOLESALER-EDIT'])){
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <mat-icon aria-hidden="false" aria-label="Edit icon" fontIcon="edit"
                                        (click)="openModel('Edit', element._id)" class="c_btn">
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>
                        }

                         @if(userDataService?.roleMatch(['SWITCH-DISTRIBUTOR-TYPE'])){
                          <ng-container matColumnDef="switch">
                            <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 200px;"> Switch
                                Distributor
                              </th>

                            <td mat-cell *matCellDef="let element" class="text-nowrap">
                                <!-- {{element?.distributorType===1?'WHOLESALER':'RETAILER'}} -->
                                <div class="align-items-center text-center">
                                    <button type="button" class="btn btn-sm rounded-circle switch-btn me-1"
                                        (click)="switchDistributor(element)"
                                        [ngClass]="'btn-wholesaler'"
                                        title="Switch Distributor">
                                        <i class="bi bi-arrow-repeat"></i>
                                    </button>
                                    <br>
                                    <span class="fw-semibold text-primary">WHL → RTL</span>
                                </div>
                            </td>

                        </ng-container>
                        }
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                No data available
                            </td>
                        </tr>
                    </table>

                </div>
            </div>

            <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllWholeSalers($event)">
            </mat-paginator>

        </app-card>
    </div>
</div>



<!-- Button trigger modal -->


<!-- Modal -->

<div class="modal fade" id="registerModal" tabindex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title fs-5 fw-semibold" id="registerModalLabel">{{formType}} Wholesaler</h5>
                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>
            <div class="modal-body pt-3">

                <div class="card mb-3">
                    @if (distributorSearchInput) {
                    <div class="row align-items-end">
                        <div class="col-9 mb-1">
                            <label for="dSearch" class="form-label">Search distributor</label>
                            <input type="text" id="dSearch" [(ngModel)]="searchText"
                                class="form-control form-control-sm" placeholder="e.g. John Distributors"
                                tooltip="Type name and click 'Search'" />
                        </div>
                        <div class="col-3 ">
                            <button class="btn btn-primary btn-sm" (click)="onDistributorSearch()">
                                <i class="bi bi-search"> </i> Search
                            </button>
                        </div>
                    </div>
                    }
                </div>


                @if (distributors?.length > 0) {
                <div class="row mb-2">
                    <div class="col-12 text-end">
                        <button class="btn btn-sm btn-primary d-inline-flex align-items-center" (click)="showForm()">
                            <i class="bi bi-plus-lg me-1"></i> Add New
                        </button>
                    </div>
                </div>
                @if (distributors?.length > 0) {
                <div class="table-responsive">
                    <table class="table table-bordered table-sm table-hover align-middle" style="font-size: 12px;">
                        <thead class="table-primary">
                            <tr class="text-nowrap">
                                <th class="py-1">#</th>
                                <th class="py-1">Name</th>
                                <th class="py-1">Email</th>
                                <th class="py-1">Phone</th>
                                <th class="py-1" style="width: 100px;">Address</th>
                                <th class="py-1 text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (d of distributors; track $index) {
                            <tr class="text-nowrap">
                                <td class="py-1">{{ $index+1 }}</td>
                                <td class="py-1">{{ d.name }}</td>
                                <td class="py-1">{{ d.email || 'N/A' }}</td>
                                <td class="py-1">{{ d.phone || 'N/A' }}</td>
                                <td class="py-1" style="width: 100px;">
                                    <div style="width: 200px; white-space: normal; word-wrap: break-word;">
                                        @if (d?.address) {
                                        {{ d.address }},
                                        }
                                        @if (d?.city) {
                                        <br>
                                        {{ d.city }},
                                        }
                                        @if (d?.state) {
                                        {{ d.state }}
                                        }

                                    </div>
                                </td>
                                <td class="py-1 text-center">
                                    <button class="btn btn-outline-primary btn-xs p-0 px-1"
                                        style="font-size: 11px; height: 22px;" (click)="companyDistributorSearch(d)">
                                        <i class="bi bi-plus-circle"></i>
                                    </button>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

                }

                }



                @if (showRegisterForm) {
                <form [formGroup]="registerForm" (ngSubmit)="submit()">
                    <div class="row g-2">

                        <!-- Name -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Name</label>
                            <input type="text" formControlName="name" class="form-control form-control-sm py-1"
                                placeholder="Enter Name">
                            @if (registerForm.get('name')?.invalid && (registerForm.get('name')?.touched ||
                            registerForm.get('name')?.dirty)) {
                            <small class="text-danger">Name is required</small>
                            }
                        </div>

                        <!-- Phone -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Phone</label>
                            <input type="text" formControlName="phone" class="form-control form-control-sm py-1"
                                placeholder="Enter Phone Number">
                            @if (registerForm.get('phone')?.invalid && (registerForm.get('phone')?.touched ||
                            registerForm.get('phone')?.dirty)) {
                            <small class="text-danger">Enter a valid 10-digit phone number</small>
                            }
                        </div>

                        <!-- Email -->
                        <!-- Email Field -->
                        <div [ngClass]="formType === 'Edit' ? 'col-md-12' : 'col-md-6'">
                            <label class="form-label fw-semibold text-muted small">Email</label>
                            <input type="email" formControlName="email" class="form-control form-control-sm py-1"
                                placeholder="Enter Email" [readonly]="formType === 'Edit'">

                            @if (registerForm.get('email')?.invalid && (registerForm.get('email')?.touched ||
                            registerForm.get('email')?.dirty)) {
                            <small class="text-danger">
                                Email is required
                            </small>
                            }
                        </div>


                        @if (formType !== 'Edit') {
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Password</label>
                            <input type="password" formControlName="password" class="form-control form-control-sm py-1"
                                placeholder="Enter Password">

                            @if (registerForm.get('password')?.invalid && (registerForm.get('password')?.touched ||
                            registerForm.get('password')?.dirty)) {
                            <small class="text-danger">
                                Password is required
                            </small>
                            }
                        </div>
                        }


                        <div class="col-md-12">
                            <label class="form-label fw-semibold text-muted small">GST Number</label>
                            <input type="text" formControlName="gstNo" class="form-control form-control-sm py-1"
                                placeholder="Enter GST Number">
                            @if (registerForm.get('gstNo')?.invalid && (registerForm.get('gstNo')?.touched ||
                            registerForm.get('gstNo')?.dirty)) {
                            <small class="text-danger">GST No is required</small>
                            }
                        </div>
                        <hr class="mb-0">
                        <hr class="my-0">
                        <div class="col-md-12">
                            <label class="form-label fw-semibold text-muted small">Address</label>
                            <textarea formControlName="address" class="form-control form-control-sm py-1" rows="2"
                                placeholder="Enter Address"></textarea>
                            @if (registerForm.get('address')?.invalid && (registerForm.get('address')?.touched ||
                            registerForm.get('address')?.dirty)) {
                            <small class="text-danger">Address is required</small>
                            }
                        </div>

                        <!-- City -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">City</label>
                            <input type="text" formControlName="city" list="cities"
                                class="form-control form-control-sm py-1" placeholder="Enter City">
                            @if (registerForm.get('city')?.invalid && (registerForm.get('city')?.touched ||
                            registerForm.get('city')?.dirty)) {
                            <small class="text-danger">City is required</small>
                            }
                        </div>

                        <!-- State -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">State</label>
                            <input type="text" formControlName="state" list="states"
                                class="form-control form-control-sm py-1" placeholder="Enter State">
                            @if (registerForm.get('state')?.invalid && (registerForm.get('state')?.touched ||
                            registerForm.get('state')?.dirty)) {
                            <small class="text-danger">State is required</small>
                            }
                        </div>

                        <!-- Latitude -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Latitude(Optional)</label>
                            <input type="number" formControlName="latitude" class="form-control form-control-sm py-1"
                                placeholder="Enter Latitude">
                        </div>

                        <!-- Longitude -->
                        <div class="col-md-6">
                            <label class="form-label fw-semibold text-muted small">Longitude(Optional)</label>
                            <input type="number" formControlName="longitude" class="form-control form-control-sm py-1"
                                placeholder="Enter Longitude">
                        </div>

                        <!-- GST No and Address on same row -->

                    </div>

                    <!-- Submit Buttons -->
                    <div class="modal-footer border-0 pt-3 d-flex justify-content-end">
                        <button type="button" class="btn btn-sm btn-light me-2" (click)="hideModel()">Cancel</button>
                        <button type="submit" class="btn btn-sm btn-primary px-3"
                            [disabled]="formType === 'Add' && registerForm.invalid">Save</button>
                    </div>
                </form>
                }




            </div>


        </div>
    </div>
</div>

<datalist id="cities">
    @for(city of cities;track $index){
    <option [value]="city">{{city}}</option>
    }
</datalist>

<datalist id="states">
    @for(state of states;track $index){
    <option [value]="state">{{state}}</option>
    }
</datalist>
